import React, { useEffect, useState } from 'react';
import { actions } from 'redux/actions';
import Shared from 'screens/shared';

import { ACTIONS_TYPES } from 'redux/helper';
import {
  _t, sleep, shortText, copyToClipboard,
} from 'utils';
import { Button, Checkbox } from '@mui/material';
import { service } from 'services';
import { useSelector } from 'react-redux';
import { ROUTE } from 'constant';
import useFilter from './hooks/group-filter';

export default ({ userId, history }) => {
  const [deleteId, setDeleteId] = useState('');
  const [deleteS3KeyId, setDeleteS3KeyId] = useState('');
  const [s3Keys, setS3Keys] = useState([]);

  const [groups, FilterComponent] = useFilter();
  const { user = {}, listViewType = '' } = useSelector((e) => e);
  const { properties: userProps = {} } = user;
  const { administrator = false } = userProps;

  const fields = [
    {
      name: 'group',
      type: 'group',
      style: { marginTop: 15 },
    },
  ];

  const addUserToGroup = (groupId) => {
    actions.group.addUser({ groupId, userId });
  };

  const CreateForm = () => (
    <Shared.forms.Form
      fields={fields}
      fieldsValues={{}}
      onSubmit={({ group: { id = '' } }) => addUserToGroup(id)}
      isCancel={false}
    />
  );

  useEffect(() => {
    actions.user.get({ userId });
    service.user.getAllS3Keys({ userId })
      .then((e) => setS3Keys(e.items || []));
  }, [userId]);

  const selectToDelete = (id) => {
    setDeleteId(id);
  };

  const onDeleteUser = (confirmState) => {
    if (confirmState) {
      actions.group.deleteUser({ userId, groupId: deleteId });
    }
    setDeleteId('');
  };

  const selectToDeleteS3Key = (id) => {
    setDeleteS3KeyId(id);
  };

  const onDeleteS3Key = (confirmState) => {
    if (confirmState) {
      service.user.deleteS3Key({ userId, keyId: deleteS3KeyId })
        .then(() => {
          service.user.getAllS3Keys({ userId })
            .then((e) => setS3Keys(e.items || []));
        });
    }

    setDeleteS3KeyId('');
  };

  const createS3KeyHandler = () => {
    service.user.createS3Key({ userId })
      .then(() => {
        service.user.getAllS3Keys({ userId })
          .then((e) => setS3Keys(e.items || []));
      });
  };

  const s3Activehandler = (active, id) => {
    setS3Keys((s) => ([...s.map((e) => ({ ...e, busy: e.id === id }))]));
    service.user.updateS3KeyActiveState({ userId, keyId: id, active })
      .then(() => {
        sleep(3000).then(() => {
          service.user.getAllS3Keys({ userId })
            .then((e) => {
              setS3Keys([...e.items] || []);
            });
        });
      });
  };

  const gotoGroupPage = (id) => {
    history.push(ROUTE.DASHBOARD.USER_MANAGEMENT_GROUP.path.replace(':id', id));
  };

  const copyText = (str) => {
    copyToClipboard(str);
    alert('The Key has been copied to the clipboard!');
  };

  return (
    <div>
      {!administrator && (
        <Shared.widgets.Cards
          title={_t('Group Memberships')}
          type="common"
          onFilter={() => ''}
          filterRender={FilterComponent}
          addAction={ACTIONS_TYPES.GROUP.ADD_USER}
          addRender={<CreateForm />}
          style={{ marginBottom: 20 }}
        >
          {listViewType === 'table' ? (
            <Shared.widgets.TableView
              name="servers"
              rows={
                groups.map((group) => {
                  const { properties, id } = group;
                  const {
                    name,
                  } = properties;

                  return ([
                    <Shared.widgets.Icon name="users" style={administrator ? { color: 'var(--color-base)' } : {}} />,
                    {
                      value: name,
                      link: id,
                    },
                    <Shared.widgets.Icon name="trash" style={{ color: 'var(--color-danger)' }} onClick={() => selectToDelete(id)} />,
                  ]);
                })
              }
              onCellClick={(id) => gotoGroupPage(id)}
              columns={[
                { name: '' },
                { name: 'Name' },
                { name: '' },
              ]}
            />
          ) : (groups.map((group) => {
            const { properties, id } = group;
            const {
              name,
            } = properties;

            return (
              <Shared.widgets.CardBasic
                key={id}
                icon="users"
                title={name}
                actionButtons={{
                  delete: () => selectToDelete(id),
                  arrow: () => gotoGroupPage(id),
                }}
              />
            );
          }))}
        </Shared.widgets.Cards>
      )}

      <Shared.widgets.Cards
        title="S3 Keys"
        type="common"
        onFilter={() => ''}
        isFilter={false}
        addRender={(
          <div style={{
            padding: 20,
          }}
          >
            <Button variant="contained" size="small" color="primary" onClick={createS3KeyHandler}>Genrate New Key</Button>
          </div>
        )}
      >
        {listViewType === 'table' ? (
          <Shared.widgets.TableView
            name="servers"
            rows={
              s3Keys.map(({
                id,
                properties,
                busy = false,
              }) => {
                const { secretKey, active } = properties;

                return ([
                  <Shared.widgets.Icon name="key" />,
                  <span title={id}>
                    {shortText(id, 8)}
                    {' '}
                    <span
                      onClick={() => copyText(id)}
                      style={{
                        color: 'var(--color-link)', cursor: 'pointer', fontSize: 12, borderBottom: '1px dotted',
                      }}
                    >
                      Copy
                    </span>
                  </span>,
                  <span title={secretKey}>
                    {shortText(secretKey, 8)}
                    {' '}
                    <span
                      onClick={() => copyText(secretKey)}
                      style={{
                        color: 'var(--color-link)', cursor: 'pointer', fontSize: 12, borderBottom: '1px dotted',
                      }}
                    >
                      Copy
                    </span>
                  </span>,
                  busy ? (
                    <Shared.widgets.Loader isInline show size={24} />
                  ) : (
                    <>
                      <Checkbox
                        checked={active}
                        onChange={(e) => s3Activehandler(e.target.checked, id)}
                        name="checkedB"
                        color="primary"
                      />
                      {active ? 'Active' : 'Inactive'}
                    </>
                  ),
                  <Shared.widgets.Icon name="trash" style={{ color: 'var(--color-danger)' }} onClick={() => selectToDeleteS3Key(id)} />,
                ]);
              })
            }
            onCellClick={(id) => gotoGroupPage(id)}
            columns={[
              { name: '' },
              { name: 'Key' },
              { name: 'Secret' },
              { name: 'Status' },
              { name: '' },
            ]}
          />
        ) : (s3Keys.map(({
          id,
          properties,
          busy = false,
        }) => {
          const { secretKey, active } = properties;

          return (
            <Shared.widgets.CardBasic
              key={id}
              icon="key"
              details={(
                <>
                  <span style={{ display: 'block' }}>
                    {id}
                    {' '}
                    <span
                      style={{
                        color: 'var(--color-link)', cursor: 'pointer', fontSize: 13, borderBottom: '1px dotted',
                      }}
                      onClick={() => copyText(id)}
                    >
                      Copy
                    </span>
                  </span>
                  <span style={{ fontSize: 12 }}>
                    {secretKey}
                    {' '}
                    <span
                      style={{
                        color: 'var(--color-link)', cursor: 'pointer', fontSize: 11, borderBottom: '1px dotted',
                      }}
                      onClick={() => copyText(secretKey)}
                    >
                      Copy
                    </span>
                  </span>
                  <div style={{ marginLeft: -10 }}>
                    {busy ? (
                      <Shared.widgets.Loader isInline show size={32} />
                    ) : (
                      <>
                        <Checkbox
                          checked={active}
                          onChange={(e) => s3Activehandler(e.target.checked, id)}
                          name="checkedB"
                          color="primary"
                        />
                        {active ? 'Active' : 'Inactive'}
                      </>
                    )}
                  </div>
                </>
              )}
              actionButtons={{
                delete: () => selectToDeleteS3Key(id),
              }}
            />
          );
        }))}
      </Shared.widgets.Cards>

      <Shared.dialog.Confirm show={!!deleteS3KeyId} onClose={onDeleteS3Key} />
      <Shared.dialog.Confirm show={!!deleteId} onClose={onDeleteUser} />
    </div>
  );
};
